
    <ng-container
      *ngTemplateOutlet="template; context: templateContext">
    </ng-container>
  